<!-- TODO: Multilang -->
<template>
  <div>
    <v-btn
      icon
      @click="open"
    >
      <v-icon>
        {{ custom_icon || 'mdi-eye-outline' }}
      </v-icon>
    </v-btn>
      <ModalDialogForm
        :showModalDialog="showModalDialog"
        :submit_button_text="readonly ? 'Aceptar' : null"
        :clear_button_text="readonly ? 'Cancelar' : null"
        @submit="submit"
        @close-dialog="close"
        @clear="clear"
      >
        <template v-slot:modal_content>
          <FormInput
            class="qmkey-transition"
            :raw_fields="raw_fields"
            :parsed_fields="parsed_fields"
            :bp="bp"
            :readonly="readonly"
            :lang="lang"
            :is_mobile="is_mobile"
            @update="update"
          />
        </template>
      </ModalDialogForm>
  </div>
</template>


<style lang="scss">
</style>


<script>
  import FormInput from '@/components/bpcreator/inputs/FormInput';
  import ModalDialogForm from '@/components/explorer/ModalDialog';
  export default {
    name: 'DialogFormInput',

    components: {
      FormInput,
      ModalDialogForm,
    },

    props: {
      raw_fields: {default: () => ({})},
      parsed_fields:  {default: () => ({})},
      bp: {default: () => ({})},
      bp_index: Number,
      data: {default: () => ({})},
      readonly: Boolean,
      is_mobile: Boolean,
      lang: String,
      custom_icon: {type: String, default: 'mdi-eye-outline'},
    },
    data() {
      return {
        showModalDialog: false,
        values: null,
      }
    },

    computed: {
    },
    
    methods: {
      open() {
        this.showModalDialog = true;
        this.values = JSON.parse(JSON.stringify(this.raw_fields));
      },
      close() {
        this.showModalDialog = false;
        if (!this.readonly) {
          this.update(this.values);
        }
      },
      clear() {
        if (!this.readonly) {
          this.update([]);
        } else {
          this.$nextTick(()=>{
            this.close();
          })
        }
      },

      submit() {
        this.showModalDialog = false;
      },

      update(value) {
        this.$emit('update',value)
      },


     centro_logo(centro) {
       const failed = this.logofails_set.has(centro.id);
       return resolve_logo(centro.logo, failed);
     },

    },
  }
</script>
